import {RequestInfo, RequestKeys} from "../../../shared-components/constants/requests"
import * as fromRequests from "../../../shared-components/store/requests/requestsReducer"
import * as sapStorage from "../../localStorage/sapReducer"

/**
 * Get the texts from the store.
 */
export const getTexts = (state, contractId) => sapStorage.getTexts(state.localStorage.sap, contractId)
/**
 * Is the application fetching texts ?
 */
export const isFetchingTexts = state =>
    fromRequests.isFetching(RequestInfo[RequestKeys.RETRIEVE_TEXTS].name, state.requests)
/**
 * Are texts customized ?
 */
export const isCustomizedTexts = (state, contractId) =>
    sapStorage.areCustomizedTexts(state.localStorage.sap, contractId)
